<template>
  <AppLayout>
    <div class="transaction">
      <section id="transaction-products">
        <div class="container">
          <h6 class="fw-bold text-primary">Suppliers
            <button class="btn-style small pull-right" style="margin-top: -6px; margin-left:10px;" @click="$router.push('/suppliers/bulk')">Bulk Upload</button>
          </h6>
          <div class="warehouse-inventory-card-wrapper">
            <div class="warehouse-inventory-card">
              <p>Total Suppliers</p>
              <strong class="blue">{{ totalSuppliers }}</strong>
            </div>
            <div class="warehouse-inventory-card">
              <p>Pre-qualified</p>
              <strong class="blue">{{ prequalifiedCount }}</strong>
            </div>
            <div class="warehouse-inventory-card">
              <p>Not Pre-qualified</p>
              <strong class="blue">{{ notPrequalifiedCount }}</strong>
            </div>
            <div class="warehouse-inventory-card">
              <p>With Documents</p>
              <strong class="blue">{{ withDocumentsCount }}</strong>
            </div>
            <div class="warehouse-inventory-card">
              <p>With Purchases</p>
              <strong class="blue">{{ withPurchasesCount }}</strong>
            </div>
            <div class="warehouse-inventory-card">
              <p>Auto Applicants Not Pre-qualified</p>
              <strong class="blue">{{ applicantsAutoNotPrequalifiedCount }}</strong>
            </div>
          </div>
  
          <div class="filter-search"  style="margin-top: -10px; padding-left: 0px;">
            <div class="filter-search-header">
              <p>Filter</p>
              <p class="clear" @click="clear">Clear</p>
            </div>
            <div class="filter-search-body">
              <div class="form">
                <div class="row">
                  <div class="col-md-2 align-self-end">
                    <div class="form-group">
                      <label for="date">Supplier Name</label>
                      <input type="text" class="form-control" v-model="supplierName">
                    </div>
                  </div>
                  
                  <div class="col-md-2 align-self-end">
                    <div class="form-group">
                      <label for="date">Supplier Code</label>
                      <input type="text" class="form-control" v-model="supplierCode">
                    </div>
                  </div>
                  
                  <div class="col-md-2 align-self-end">
                    <div class="form-group">
                      <label for="date">Nature of Business</label>
                      <input type="text" class="form-control"  v-model="businessNature">
                    </div>
                  </div>
                  
                  <div class="col-md-2 align-self-end">
                    <div class="form-group">
                      <label for="handled-by">Qualification Status</label>
                      <select class="full" id="handled-by" v-model="qualification">
                        <option value="All">All</option>
                        <option value="Pre-qulaified">Pre-qualified</option>
                        <option value="Not Pre-qualified">Not Pre-qualified</option>
                      </select>
                    </div>
                  </div>

                  <!--
                    <div class="col-md-1 align-self-end">
                      <div class="form-group">
                        <a href="#" class="btn-style small">Filter</a>
                      </div>
                    </div>
                  -->
                  
                </div>
              </div>
            </div>
          </div>
  
          <div class="products-list transaction-products-list" style="margin-top: 0px">
                <!--<strong style="margin-top: 0px;">Suppliers List</strong>
                
                 Skeleton loader for suppliers table -->
                <SkeletonLoader v-if="loading" type="table" :rows="6" :columns="7" />
                
                <table v-else class="table table-hover" id="suppliersTable">
                    <thead>
                        <th style="background-color: #f8f9fa; font-size: 12px; font-weight: 600; padding: 15px 8px; text-align: left;">No.</th>
                        <th style="background-color: #f8f9fa; font-size: 12px; font-weight: 600; padding: 15px 8px; text-align: left;">Supplier Name & Code</th>
                        <th style="background-color: #f8f9fa; font-size: 12px; font-weight: 600; padding: 15px 8px; text-align: left;">Nature of Business</th>
                        <th style="background-color: #f8f9fa; font-size: 12px; font-weight: 600; padding: 15px 8px; text-align: left;">Procurement Categories</th>
                        <th style="background-color: #f8f9fa; font-size: 12px; font-weight: 600; padding: 15px 8px; text-align: left;">Status</th>
                        <th style="background-color: #f8f9fa; font-size: 12px; font-weight: 600; padding: 15px 8px; text-align: left;">No. of POs</th>
                        <th style="background-color: #f8f9fa; font-size: 12px; font-weight: 600; padding: 15px 8px; text-align: left;">PO Amount to Date</th>
                        <th style="background-color: #f8f9fa; font-size: 12px; font-weight: 600; padding: 15px 8px; text-align: left;">Action</th>
                    </thead>
                    <tbody>
                        <tr v-for="(supplier, index) in suppliers" :key="supplier.id">
                            <td>{{ index + 1 }}</td>
                            <td>{{ supplier?.name }} - {{ supplier?.code }}</td>
                            <td>{{ supplier?.business }}</td>
                            <td>{{ getSupplierCategories(supplier) }}</td>
                            <td>
                                <button v-if="supplier?.prequalified" class="btn btn-primary btn-sm" style="border-radius: 15px">Pre-qualified</button>
                                <button v-else class="btn btn-danger btn-sm" style="border-radius: 15px">Not Pre-qualified</button>
                            </td>
                            <td>{{ supplier?.purchases?.length || 0 }}</td>
                            <td>{{ formatMoney(getTotal(supplier?.purchases)) }}</td>
                            <td>
                                <router-link :to="`/suppliers/${supplier.id}`" class="btn btn-sm btn-default" style="border: 1px solid black;">View Details</router-link>
                            </td>
                        </tr>
                        <tr v-if="suppliers?.length === 0 && !loading">
                            <td colspan="7" class="text-center text-danger">No suppliers found</td>
                        </tr>
                    </tbody>
                </table>
              <!-- <LoaderItem v-if="loading"/> -->
              <!--
                <div v-if="suppliers.length < 1">
                  <label for="" class="alert alert-danger" style="margin: 0px auto; width: fit-content; display: block;">No supplier found</label>
                </div>
              -->
                
          </div>
        </div>
      </section>
    </div>
  </AppLayout>
</template>
  
  <script>
  
import AppLayout from '../../components/AppLayout.vue';
import SkeletonLoader from '../../components/SkeletonLoader'
import 'datatables.net-vue3';
import 'datatables.net-bs5';
import "datatables.net-buttons-bs5";
import "datatables.net-responsive-bs5";
import 'jszip';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.colVis.js';
import 'datatables.net-buttons/js/buttons.print.js';
// docFooter not used in this view


  export default {
    name: 'SuppliersPage',
    components: {
      AppLayout,
      SkeletonLoader
    },
    computed: {
      totalSuppliers() {
        return this.suppliers?.length || 0;
      },
      prequalifiedCount() {
        return (this.suppliers || []).filter(s => !!s.prequalified).length;
      },
      notPrequalifiedCount() {
        return (this.suppliers || []).filter(s => !s.prequalified).length;
      },
      applicantsAutoNotPrequalifiedCount() {
        return (this.suppliers || []).filter(s => !!s.createdViaTenderApplication && !s.prequalified).length;
      },
      withDocumentsCount() {
        return (this.suppliers || []).filter(s => (s.documents && s.documents.length > 0)).length;
      },
      withPurchasesCount() {
        return (this.suppliers || []).filter(s => (s.purchases && s.purchases.length > 0)).length;
      }
    },
    data: () => ({
        token: JSON.parse(localStorage.getItem('access_token')),
        suppliers: [],
        processedData: [],
        loading: false,
        supplierName: "", 
        supplierCode: "", 
        businessNature: "",
        qualification: "",
        dataTable: null,
    }),
    mounted(){
        this.getSuppliers()
    },
    beforeUnmount() {
      if (this.dataTable) {
        this.dataTable.destroy();
        this.dataTable = null;
      }
    },
    methods:{
      getTotal(arrayL){
        //console.log( {arrayL})
        if(arrayL){
          let total =0;
          arrayL.forEach(element => {
            element.PurchaseProduct.forEach( smallEl => {
              total = total+ smallEl.price
            })
          });
          return total;
        } else{
          return 0;
        }
      },

      clear(){
        this.supplierName = ""
        this.supplierCode = ""
        this.businessNature = ""
        this.qualification = "All"
      },
      getSupplierCategories(sup) {
        if (!sup) return ''
        const cats = []
        if (sup.procurementCategories && Array.isArray(sup.procurementCategories)) cats.push(...sup.procurementCategories.filter(Boolean))
        if (sup.SupplierTenderCategory && Array.isArray(sup.SupplierTenderCategory)) {
          sup.SupplierTenderCategory.forEach(sc => {
            if (sc && sc.tenderCategory && sc.tenderCategory.name) cats.push(sc.tenderCategory.name)
          })
        }
        if (sup.procurementCategory) cats.push(sup.procurementCategory)
        if (sup.procurement_category) cats.push(sup.procurement_category)
        if (sup.category) cats.push(sup.category)
        // remove duplicates and empty
        const uniq = Array.from(new Set(cats.map(c => (c || '').toString().trim()).filter(Boolean)))
        return uniq.join(', ')
      },
      
      async getSuppliers () {
            const requestOptions = {
                method: "GET",
                headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
            };
          try{
            this.loading = true
            const res = await fetch(process.env.VUE_APP_URL+'/suppliers', requestOptions)
            
            if (!res.ok) {
              console.error('Failed to fetch suppliers:', res.status, res.statusText);
              return;
            }
            
            const data = await res.json()
            
            if (Array.isArray(data)) {
              this.suppliers = data;
            } else {
              console.error('Expected array but got:', typeof data);
              this.suppliers = [];
            }
            
            }catch(err){
              console.error('Error fetching suppliers:', err);
          }finally{
              this.loading = false
          }
        }
    }
  }
  </script>

  <style scoped>
  .suppliers-list{
    padding: 20px;
    margin-top: 30px;
    box-shadow: rgba(49, 32, 104, 0.2) 0 2px 8px 0;
  }
  
  /* Custom DataTable button styling */
  :deep(.dt-buttons) {
    margin-bottom: 1rem;
  }
  
  :deep(.dt-button) {
    background-color: #f8f9fa !important;
    color: #495057 !important;
    border: 1px solid #dee2e6 !important;
    border-radius: 0 !important;
    margin: 0 !important;
    padding: 6px 12px !important;
    font-size: 11px !important;
    font-weight: 500 !important;
  }
  
  :deep(.dt-button:hover) {
    background-color: #e9ecef !important;
    color: #495057 !important;
  }
  
  :deep(.dt-button:first-child) {
    border-top-left-radius: 4px !important;
    border-bottom-left-radius: 4px !important;
  }
  
  :deep(.dt-button:last-child) {
    border-top-right-radius: 4px !important;
    border-bottom-right-radius: 4px !important;
  }
  
  :deep(.dt-button:not(:first-child)) {
    border-left: 0 !important;
  }
  </style>